module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dpHcD"))).then(() => parcelRequire('1iHdE'));